import styled, { css } from 'styled-components';

export const StatisticsCardEmptyStateWrapper = styled.div(
    ({ theme: { palette } }) => css`
        align-items: center;
        display: flex;
        flex-direction: column;
        gap: 24px;
        justify-content: center;
        height: 100%;

        p {
            color: ${palette.text.assistive};
        }
    `,
);
